// extracted by mini-css-extract-plugin
export default {"btnsBox":"ModalAction_btnsBox__KXz+H","confirmBtn":"ModalAction_confirmBtn__TRYlJ"};